import React from 'react';
import Toolbar from '../../components/common/Toolbar';
import ActivationServices from '../../components/blocks/ActivationServices';

export default function ActivationServicesContainer(props) {
  return (
    <>
      <Toolbar name="Services" />
      <ActivationServices />
    </>
  );
}
